export default __webpack_public_path__ + "static/media/outfit_teckwear.89516e1d.png";